module.exports = __webpack_public_path__ + "static/media/cielo-logo.71d64f16.png";